import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useUserContext } from '../contexts/user';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useLoaderContext } from '../contexts/loader';
import { get, ref, remove, set, update } from 'firebase/database';
import { db } from '../Database';
import { usePopUpContext } from '../contexts/Popup';

const LiveChallenge = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { user, userInfo, userIndex, appLanguage } = useUserContext();
    const { isLoading, setIsLoading } = useLoaderContext();
    const { setMessageContent } = usePopUpContext();

    const [code, setCode] = useState("");

    let targetWord = "Live-Challenge";

    const codeInputRef = useRef();

    useEffect(() => {
        if (isLoading) return;
        const letters = "abdfjkmopqrstuwxyzABCDEFGHJKMNOPQRSTUVWXYZ1234567890";
        let codeLength = targetWord.length;
        let currentWord = "";
        let nextIndex = 0;
        let code = "";
        const generateCode = () => {
            for (let i = 0; i < codeLength; i++) {
                code += letters[Math.floor(Math.random() * letters.length)];
            }
            setCode(currentWord + code);
        }
        let generateInterval = setInterval(() => {
            code = "";
            generateCode();
        }, 100)
        let addLetter = setInterval(() => {
            currentWord += targetWord[nextIndex];
            nextIndex += 1;
            codeLength--;
            if (currentWord === targetWord) {
                clearInterval(addLetter);
                clearInterval(generateInterval);
                setCode(targetWord);
            }
        }, 1000)
        return () => {
            clearInterval(generateInterval);
            clearInterval(addLetter);
        };
    }, [isLoading])

    useEffect(() => {
        if (userInfo?.role === "student" && id === "create") {
            navigate("/live-challenge/join");
        } else if (userInfo?.role === "teacher" && id === "join") {
            navigate("/live-challenge/create");
        }
    }, [userInfo])

    const createChallenge = () => {
        setIsLoading(prev => prev + 1);
        const symbols = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
        const challengeLength = 10;
        let challengeCode = "";
        for (let i = 0; i < challengeLength; i++) {
            challengeCode += symbols[Math.floor(Math.random() * symbols.length)];
        }
        const challengeData = {
            creator_id: user,
            creator_name: userInfo.username,
            challenge_code: challengeCode,
            created_at: new Date().getTime(),
            status: "waiting",
        };
        set(ref(db, "challenges/" + challengeCode), challengeData).then(() => {
            update(ref(db, "users/" + userInfo.id), {
                challenge: challengeCode,
            }).then(() => {
                navigate("/challenge/" + challengeCode);
                setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
            }).catch(async () => {
                await remove(ref(db, "challenges/" + challengeCode));
                setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                setMessageContent({
                    title: appLanguage === "ar" ? "خطأ في إنشاء التحدي" : "Creating Challenge Error",
                    message: appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء إنشاء التحدي الخاص بك." : "Oops! something went wrong while creating your challenge.",
                })
            })
        }).catch(() => {
            setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
            setMessageContent({
                title: appLanguage === "ar" ? "خطأ في إنشاء التحدي" : "Creating Challenge Error",
                message: appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء إنشاء التحدي الخاص بك." : "Oops! something went wrong while creating your challenge.",
            })
        })
    }

    const joinChallenge = () => {
        const code = codeInputRef?.current.value.replace(" ", "").trim();
        if (code && code.length === 10) {
            setIsLoading(prev => prev + 1);
            get(ref(db, "challenges/" + code)).then(snapShot => {
                const challenge = snapShot.val();
                setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                if (!challenge) {
                    setMessageContent({
                        title: appLanguage === "ar" ? "لم يتم العثور على التحدي" : "Challenge Not Found",
                        message: appLanguage === "ar" ? "لم يتم العثور على التحدي في قاعدة البيانات الخاصة بنا." : "Challenge is not found in our database.",
                    })
                } else {
                    if (!challenge.users?.find(user => user.user_id === userInfo.id)) {
                        if (challenge.status === "waiting") {
                            const userData = {
                                username: userInfo.username,
                                user_id: userInfo.id,
                            };
                            update(ref(db, "users/" + userInfo.id), {
                                challenge: code,
                            }).then(() => {
                                update(ref(db, "challenges/" + code), {
                                    users: challenge.users ? [...challenge.users, userData] : [userData],
                                }).then(() => {
                                    navigate("/challenge/" + code);
                                    setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                                }).catch(() => {
                                    setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                                    setMessageContent({
                                        title: appLanguage === "ar" ? "فشل الانضمام" : "Joining Failed",
                                        message: (appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء إضافتك إلى هذه الغرفة '" : "Oops! something went wrong while adding you to this room '") + code + "'.",
                                    })
                                    update(ref(db, "users/" + userInfo.id), {
                                        challenge: "",
                                    })
                                })
                            }).catch(() => {
                                setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                                setMessageContent({
                                    title: appLanguage === "ar" ? "فشل الانضمام" : "Joining Failed",
                                    message: (appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء إضافتك إلى هذه الغرفة '" : "Oops! something went wrong while adding you to this room '") + code + "'.",
                                })
                            })
                        } else {
                            setMessageContent({
                                title: appLanguage === "ar" ? "لا يمكن الدخول" : "Can't Enter",
                                message: appLanguage === "ar" ? "عذراً! لا يمكنك دخول هذا التحدي لأنه ليس في حالة الانتظار." : "Oops! You can't enter this challenge because it's not in the waiting state.",
                            })
                        }
                    } else {
                        navigate("/challenge/" + code);
                    }
                }
            }).catch(() => {
                setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                setMessageContent({
                    title: appLanguage === "ar" ? "فشل الانضمام" : "Joining Failed",
                    message: (appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء إضافتك إلى هذه الغرفة '" : "Oops! something went wrong while adding you to this room '") + code + "'.",
                })
            })
        } else {
            setMessageContent({
                title: appLanguage === "ar" ? "شيء مفقود" : "Missing something",
                message: appLanguage === "ar" ? "لا يمكنك البحث بمدخل فارغ أو برمز طوله لا يساوي 10." : "You can't search with an empty input or with a code it's length is not equal to 10.",
            })
        }
    }

    return (
        <div className="live_challenge_container">
            <header>
                <ChevronLeft onClick={() => navigate("/home")} />
                <p>{appLanguage === "ar" ? "تحدي مباشر" : "Live Challenge"}</p>
            </header>
            <div className="content">
                {
                    userInfo.role === "teacher" && id === "create" ?
                        <div className="create_challenge">
                            <div className="game_code">{code.split("").map((letter, i) => {
                                return <p key={"letter_" + i} className={letter === targetWord[i] ? "active" : ""}>{letter}</p>
                            })}</div>
                            <p className="note">{appLanguage === "ar" ? "أنشئ التحدي الخاص بك وادع طلابك للدخول إليه من خلال رمز التحدي." : "Create your challenge and invite your students to enter it form the challenge code."}</p>
                            <button onClick={createChallenge}>
                                <span>{appLanguage === "ar" ? "إنشاء تحدي" : "Create Challenge"}</span>
                                <ChevronRight />
                            </button>
                        </div>
                        : (
                            id === "join" ?
                                <div className="join_challenge">
                                    <div className="game_code">{code.split("").map((letter, i) => {
                                        return <p key={"letter_" + i} className={letter === targetWord[i] ? "active" : ""}>{letter}</p>
                                    })}</div>
                                    <input type="text" ref={codeInputRef} placeholder={appLanguage === "ar" ? "رمز التحدي المباشر" : "Live Challenge Code"} />
                                    <button onClick={joinChallenge}>
                                        <span>{appLanguage === "ar" ? "انضمام للتحدي" : "Join Challenge"}</span>
                                        <ChevronRight />
                                    </button>
                                </div> : <></>
                        )
                }
            </div>
        </div>
    )
}

export default LiveChallenge;